import React, {useEffect, useState} from 'react';
import {Time} from './time';
import {Board} from './board';
import {Debug} from './debug';
import {Hero} from './hero';

const IS_DEV = process.env.NODE_ENV === 'development';

export function BoardApp(): React.ReactElement {
  const [date, setDate] = useState(new Date());
  const [debugDate, setDebugDate] = useState<Date | null>(null);

  useEffect(() => {
    setInterval(() => {
      setDate(new Date());
    }, 1000);
  }, []);

  // TODO Debug 23:59

  const dateToPass = debugDate || date;

  return (
    <div
      className="w-[100vw] h-[100vh] relative drop-shadow-xl border-b-1 border-blue-800 border-solid
    "
    >
      {IS_DEV && <Debug onChangeDate={setDebugDate} />}
      <Board date={dateToPass} />
      <Time date={dateToPass} />
      <Hero />
    </div>
  );
}
